import{jsx as r,jsxs as t}from"react/jsx-runtime";import{useLocation as e}from"react-router-dom";import{styled as n}from"styled-components";import{TabContextProvider as o}from"../context/TabContext.mjs";const a=n.div`
  border-radius: 4px;
  padding: 0.2em;
`,m=n.div.attrs({className:"tabs"})`
  display: flex;
`;function c(n,c,i){return function(){var s;const d=e(),p=null!==(s=new URLSearchParams(d.search).get("currentTab"))&&void 0!==s?s:n;return r(a,{children:t(o,{value:{currentTab:p},children:[r(m,{children:c.map(((t,e)=>r(t,{},e)))}),i.map(((t,e)=>r(t,{},e)))]})})}}export{c as hoMainMenu};
